// StudentContext.js
import report from 'common/utils/errorReporter'
import { LogLevel } from 'common/utils/types/log-entry'
import { StudentSession } from 'common/utils/types/student-session'
import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
} from 'react'

export const StudentContext = createContext<{
  studentSession: StudentSession
  disableAnimation: boolean
  setDisableAnimation: React.Dispatch<React.SetStateAction<boolean>>
  enableCaptions: boolean
  setEnableCaptions: React.Dispatch<React.SetStateAction<boolean>>
  error: any
  setError: React.Dispatch<React.SetStateAction<any>>
}>(null)

export const useStudentContext = () => useContext(StudentContext)

export function StudentProvider({ children }) {
  const [studentSession, setStudentSession] = useState<StudentSession>()
  const [disableAnimation, setDisableAnimation] = useState<boolean>(
    localStorage.getItem('disableAnimations') === 'true'
  )
  const [enableCaptions, setEnableCaptions] = useState<boolean>(
    localStorage.getItem('enableCaptions') === 'true'
  )
  const [error, setError] = useState(null)

  useEffect(() => {
    try {
      StudentSession.load()
        .then((student) => {
          if (!student) {
            // report(
            //   LogLevel.Error,
            //   {
            //     message: 'Student session did not load',
            //     storage: JSON.stringify(sessionStorage),
            //   },
            //   'Student session did not load - including sessionStorage'
            // )
            // setError(new Error('Student session did not load'))
            window.location.href = '/#/signin/student'
          }
          setStudentSession(student)
        })
        .catch((err) => {
          console.error(err)
          report(
            LogLevel.Error,
            err,
            'Student session failed to load - Student Session Loading Error'
          )
          setError(err)
        })
    } catch (err) {
      console.error(err)
      report(
        LogLevel.Error,
        typeof err === 'object' && err !== null && 'message' in err
          ? (err as any).message
          : err?.toString?.() || String(err),
        'Student session failed to load - Student Session Error'
      )
      setError(err)
    }
  }, [])

  useEffect(() => {
    localStorage.setItem(
      'disableAnimations',
      disableAnimation ? 'true' : 'false'
    )
    localStorage.setItem('enableCaptions', enableCaptions ? 'true' : 'false')
  }, [disableAnimation, enableCaptions])

  const value = useMemo(
    () => ({
      studentSession,
      disableAnimation,
      setDisableAnimation,
      enableCaptions,
      setEnableCaptions,
      error,
      setError,
    }),
    [
      studentSession,
      disableAnimation,
      setDisableAnimation,
      enableCaptions,
      setEnableCaptions,
      error,
      setError,
    ]
  )

  return (
    <StudentContext.Provider value={value}>{children}</StudentContext.Provider>
  )
}
